import TombstoneForm from './components/TombstoneForm.vue';
import InitComponent from 'Modules/InitComponent';
import store from 'Stores/store';

const topMenuDesktop = document.getElementById('tombstone-form__vue');
const initComponent = new InitComponent({
  selectors: topMenuDesktop,
  components: { TombstoneForm },
  template: '<TombstoneForm />',
  store,
});

initComponent.init();
